import { useLanguage } from '../../utils/LanguageContext';
import { Space } from 'antd';
import { useAuth } from '../../utils/AuthContext';
import translations from './AccountSettings.lang.json';
import { Explainer, EditableValues } from '../common/CommonComponents';
import MaritalStatusView from '../MaritalStatusView';
import MaritalStatusForm from '../MaritalStatusForm';
import BeneficiariesView from '../BeneficiariesView';
import BeneficiariesForm from '../BeneficiariesForm';

const ChangeBeneficiariesInfo = () => {
  const { lang } = useLanguage(translations);
  const { user } = useAuth();

  return (
    <Space direction="vertical">
      <EditableValues
        editButtonLabel={lang('editMaritalStatus')}
        viewComponent={MaritalStatusView}
        editComponent={MaritalStatusForm}
      />

      {user.maritalStatus ? (
        <EditableValues
          editButtonLabel={lang('editBeneficiaries')}
          viewComponent={BeneficiariesView}
          editComponent={BeneficiariesForm}
        />
      ) : (
        lang('maritalStatusPrompt')
      )}
      <Explainer question={lang('beneficiariesExplainerQuestion')} answer={lang('beneficiariesExplainerAnswer')} />
    </Space>
  );
};

export default ChangeBeneficiariesInfo;
